import { notFound } from '@tanstack/react-router';
import type { Permission } from '@holymoly/core';

/**
 * Route-level permission check for `beforeLoad` (UX only — the API enforces
 * every permission itself). Unknown-to-you pages look like 404s, not 403s.
 */
export function requirePermission(me: { permissions: readonly string[] }, ...anyOf: Permission[]) {
  if (!anyOf.some((p) => me.permissions.includes(p))) throw notFound();
}
